<template>
  <header data-testid="main-nav" class="main-nav">
    <main-nav-leading
      :applist="applist"
      :clients="clients"
      :selected-client-id="selectedClientId"
      :logo-home-route="logoHomeRoute"
      :show-injector-divider="hasInjector && showInjectorDividers"
      @logo-click="$emit('logo-click', $event)"
      @app-click="$emit('app-click', $event)"
    />

    <div
      v-if="hasInjector"
      data-testid="main-nav__injector"
      class="main-nav__injector"
    >
      <div data-testid="main-nav__injector-content" class="main-nav__injector-content">
        <slot name="injector" />
        <!-- <div
          v-if="showInjectorDividers"
          class="main-nav__injector-content-divider main-nav__logo-divider"
          aria-hidden="true"
        ></div> -->
      </div>
    </div>

    <div data-testid="main-nav__trailing" class="main-nav__trailing">
      <div data-testid="main-nav__support-cluster" class="main-nav__support-cluster">
        <v-tooltip v-if="showManuals" bottom content-class="tooltip-bottom">
          <template #activator="{ on, attrs }">
            <button
              data-testid="main-nav__manuals-btn"
              type="button"
              class="main-nav__icon-btn"
              :class="{ 'main-nav__icon-btn--active': isManualsActive }"
              v-bind="attrs"
              v-on="on"
              aria-label="Product manuals"
              :aria-current="isManualsActive ? 'page' : undefined"
              @click="onManualsClick"
            >
              <img
                src="/img/icons/ManualsIcon.svg"
                alt="Product manuals"
                data-testid="main-nav__manuals-icon"
                class="main-nav__support-icon"
              />
            </button>
          </template>
          <span>Manuals</span>
        </v-tooltip>

        <v-tooltip v-if="showSupport" bottom content-class="tooltip-bottom">
          <template #activator="{ on, attrs }">
            <button
              data-testid="main-nav__support-btn"
              type="button"
              class="main-nav__icon-btn"
              v-bind="attrs"
              v-on="on"
              aria-label="Help & Support"
              @click="onSupportClick"
            >
              <img
                src="/img/icons/HelpSupportIcon.svg"
                alt="Help & Support"
                data-testid="main-nav__support-icon"
                class="main-nav__support-icon"
              />
            </button>
          </template>
          <span>Help &amp; Support</span>
        </v-tooltip>

        <profile-dropdown
          :selected-client-id="selectedClientId"
          :clients="clients"
          :fd-support-widget="fdSupportWidget"
          @logout="$emit('logout')"
          @edit-profile="$emit('edit-profile')"
          @client-change="$emit('client-change', $event)"
          @support-click="onSupportClick"
        />
      </div>
    </div>
  </header>
</template>

<script>
import ProfileDropdown from './ProfileDropdown/ProfileDropdown.vue';
import MainNavLeading from './MainNavLeading.vue';
import { hasNamedSlotContent } from './mainNavUtils';
import constants from '@/plugins/constants';

export default {
  name: 'MainNav',
  components: { ProfileDropdown, MainNavLeading },
  props: {
    showSupport: { type: Boolean, default: true },
    showManuals: { type: Boolean, default: false },
    fdSupportWidget: { type: Boolean, default: false },
    supportRoute: { type: String, default: null },
    selectedClientId: { type: String, default: '' },
    applist: { type: Array, default: () => [] },
    clients: { type: Array, default: () => [] },
    logoHomeRoute: { type: String, default: null },
    /** Vertical dividers between leading / injector / trailing — FBC top nav only */
    showInjectorDividers: { type: Boolean, default: false }
  },
  emits: [
    'support-click',
    'manuals-click',
    'logo-click',
    'logout',
    'edit-profile',
    'client-change',
    'app-click'
  ],
  computed: {
    hasInjector() {
      return hasNamedSlotContent(this, 'injector');
    },
    isManualsActive() {
      return constants.isManualsPath(this.$route.path || '');
    }
  },
  methods: {
    onSupportClick() {
      this.$emit('support-click');
    },
    onManualsClick() {
      this.$emit('manuals-click');
    }
  }
};
</script>

<style lang="scss" scoped>
@import './MainNav.scss';
</style>
